import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20coral%20and%20gold%20tones%2C%20soft%20flowing%20textures%2C%20elegant%20minimalist%20composition%2C%20digital%20art%20with%20subtle%20geometric%20elements%2C%20cinematic%20atmosphere%2C%20warm%20inviting%20mood&width=1600&height=600&seq=cta-banner-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 via-primary-800/70 to-primary-900/80"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
          开启你的韩漫之旅
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed">
          海量韩漫大全，高清画质，免费在线观看。加入500万+读者的行列，发现好看的韩国漫画！
        </p>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-accent-500 text-background-950 font-medium text-sm hover:bg-accent-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-rocket-line"></i>
          立即探索
        </Link>
      </div>
    </section>
  );
}